<template>
  <div id="openjobs-view">
    <h1>Places ouvertes</h1>
    <template>
      <div>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" persistent min-height="1700px" max-width="700px">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on">Ajouter</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ modalTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm8 v-if="addJob">
                      <v-text-field v-model="newJob.job_full_value" label="Nouveau métier"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm5 v-else>
                      <v-select
                        :items="$store.state.modulePositions.available_jobs"
                        label="Métier"
                        item-text="job_full_value"
                        item-value="job_id"
                        v-model="editedItem.job_id"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-btn flat icon color="primary" @click="addNewJob" v-if="!addJob">
                        <v-icon>add</v-icon>
                      </v-btn>
                      <v-btn flat color="primary" @click="addNewJob" v-else>Confirmer</v-btn>
                    </v-flex>
                    <v-flex xs12 sm8 v-if="addLocation">
                      <v-text-field v-model="newLocation.location_site" label="Nouveau lieu"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm5 v-else>
                      <v-select
                        :items="$store.state.modulePositions.available_locations"
                        label="Lieu"
                        item-text="location_site"
                        item-value="location_id"
                        v-model="editedItem.location_id"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm1>
                      <v-btn flat icon color="primary" @click="AddNewLocation" v-if="!addLocation">
                        <v-icon>add</v-icon>
                      </v-btn>
                      <v-btn flat color="primary" @click="AddNewLocation" v-else>Confirmer</v-btn>
                    </v-flex>

                    <v-flex xs12 sm12>
                      <v-combobox
                        v-model="editedItem.access_groups"
                        :items="$store.state.modulePositions.available_access_groups"
                        :search-input.sync="newAccessGroup.search"
                        item-text="access_group_value"
                        item-value="access_group_value"
                        label="Groupes d'accès"
                        multiple
                        small-chips
                      ></v-combobox>
                      <small>Pour ajouter un groupe non-existant, entrer sa valeur puis "Enter"</small>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="editedItem.position_spot_number"
                        label="Nombre de places"
                        type="number"
                        min="0"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="close">Annuler</v-btn>
                <v-btn color="green" flat @click="save">Confirmer</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="$store.state.modulePositions.positions"
          :pagination.sync="pagination"
        >
          <template v-slot:items="props">
            <td>{{ props.item.job_full_value }}</td>
            <td>{{ props.item.location_site }}</td>
            <td>{{props.item.access_groups.length}} groupe(s)</td>
            <td>{{ props.item.position_spot_number }}</td>
            <td>
              <v-icon class="mr-2" @click="editItem(props.item)">edit</v-icon>
              <v-icon @click="deleteItem(props.item)">delete</v-icon>
            </td>
          </template>
        </v-data-table>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'openjobs-view',
  data() {
    return {
      loaded: false,
      dialog: false,
      addJob: false,
      addLocation: false,
      headers: [
        { text: 'Métier', value: 'job_full_value' },
        { text: 'Lieu', value: 'location_site' },
        { text: 'Groupe d\'accès', value: 'position_access_group' },
        { text: 'Nombre de places', value: 'position_spot_number' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      pagination: { sortBy: 'job_full_value', descending: true, rowsPerPage: 25 },
      editedIndex: -1,
      editedItem: {
        job_id: null,
        location_id: null,
        access_groups: [],
        position_spot_number: 0
      },
      defaultItem: {
        job_id: null,
        location_id: null,
        access_groups: [],
        position_spot_number: 0
      },
      newJob: {
        job_full_value: '',
        job_short_value: ''
      },
      newLocation: {
        location_site: ''
      },
      newAccessGroup: {
        access_group_value: '',
        search: ''
      }
    }
  },
  computed: {
    modalTitle() {
      return this.editedIndex === -1 ? 'Nouvelle place' : 'Edition'
    }
  },
  watch: {
    dialog(val) {
      val || this.close()
    }
  },
  created() {
    this.loadData().then(this.loaded = true)
  },
  methods: {
    loadData() {
      return new Promise(resolve => {
        this.$store.dispatch('modulePositions/getPositions')
        this.$store.dispatch('modulePositions/getJobs')
        this.$store.dispatch('modulePositions/getLocations')
        this.$store.dispatch('modulePositions/getAccessGroups')
        resolve()
      })
    },
    editItem(item) {
      this.editedIndex = item.position_id
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem(item) {
      if (confirm('Voulez-vous vraiment supprimer cette offre ?')) {
        this.$store.dispatch('modulePositions/deletePosition', item).then(setTimeout(() => { this.loadData() }, 300))
      }
    },
    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.addJob = false
        this.addLocation = false
      }, 300)
    },
    save() {
      if (this.editedIndex != -1) {
        // Edit
        this.$store.dispatch('modulePositions/updatePosition', this.editedItem).then(setTimeout(() => { this.loadData() }, 300))
      } else {
        // create
        this.$store.dispatch('modulePositions/createPosition', this.editedItem).then(setTimeout(() => { this.loadData() }, 300))
      }
      this.close()
      // setTimeout(() => { this.loadData() }, 300)
    },
    addNewJob() {
      if (this.addJob) {
        this.$store.dispatch('modulePositions/createJob', this.newJob).then(response => {
          this.$store.dispatch('modulePositions/getJobs')
          this.addJob = false
          this.editedItem.job_id = response.id
        })
      }
      this.addJob = true
      this.addLocation = false
    },
    AddNewLocation() {
      if (this.addLocation) {
        this.$store.dispatch('modulePositions/createLocation', this.newLocation).then(response => {
          this.$store.dispatch('modulePositions/getLocations')
          this.addLocation = false
          this.editedItem.location_id = response.id
        })
      }
      this.addLocation = true
      this.addJob = false
    }
  }
}
</script>
